// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import store from './store/index'
import moment from 'moment'
import VueI18n from 'vue-i18n'
import Vue2Filters from 'vue2-filters'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import Autocomplete from './components/lib/Autocomplete'
import InputValidation from './components/lib/InputValidation'
import '../assets/scss/style.scss'
import Notify from 'vue2-notify'
import Datepicker from 'vuejs-datepicker'
import wysiwyg from "vue-wysiwyg";
import CKEditor from '@ckeditor/ckeditor5-vue';
import draggable from 'vuedraggable';
import Loading from './components/lib/Loading.vue';
import "vue-wysiwyg/dist/vueWysiwyg.css";
import VueTimepicker from 'vue2-timepicker'
import Common from './lib/Common.js';
import 'vue2-timepicker/dist/VueTimepicker.css'
import DateTimePicker from 'vue2-datepicker'
import VueSelectImage from 'vue-select-image'
import io from 'socket.io-client';
import LbDateTimePicker from 'lb-vue-datetimepicker';
import 'vue-select-image/dist/vue-select-image.css'
import
{
  library
}
from '@fortawesome/fontawesome-svg-core'
import
{
  fas
}
from '@fortawesome/free-solid-svg-icons'
import
{
  FontAwesomeIcon
}
from '@fortawesome/vue-fontawesome'

import Pagination from 'lb-vue-pagination'
import FileUpload from './components/lib/FileUpload'
import FileUploadNew from './components/lib/FileUploadNew'

library.add(fas)

var truncate = function(text)
{
  return text.slice(0, 500) + (500 < text.length ? '...' : '')
};

Vue.filter('truncate', truncate);
Vue.filter("formatdate", date => Common.formatdate(date));
Vue.prototype.moment = moment;

Vue.use(Notify,
{
  position: 'top-right'
})
Vue.$notify.notice = function(data)
{
  console.log(data);
  if (typeof data == 'object' && typeof data.error != 'undefiend')
  {
    var notice = "";
    if (typeof data.fieldErrors != 'undefined')
    {

      for (var key in data.fieldErrors)
      {
        notice += data.fieldErrors[key] + "<br>";
      }
    }
    else notice = data.notice;

    if (data.error) Vue.$notify.error(notice,
    {
      mode: 'html'
    });
    else Vue.$notify.info(notice,
    {
      mode: 'html'
    });
  }
  else Vue.$notify.info(data,
  {
    mode: 'html'
  });
}

const socket = io(null,
  {
      transports: ['websocket'],
      upgrade: false,
  });

socket.on('connect_error', () =>
{
  console.log('Socket.io connect_error');
});

socket.on('reconnect_attempt', () =>
{
  console.log('Socket.io Reconnecting');
  socket.io.opts.transports = ['websocket'];
});

socket.on('connect', () =>
{
  console.log('Socket.io connect');
  socket.emit('subscribe', { topic: 'all' });
});

socket.on('reconnect', () =>
{
  console.log('Socket.io reconnect');
  socket.emit('subscribe', { topic: 'all' });
});

Vue.prototype.$subscribe = (eventName, method) =>
{
  socket.on(eventName, method);
};

Vue.prototype.$unsubscribe = (eventName) =>
{
  socket.off(eventName);
};

Vue.use(BootstrapVue);
Vue.use(VueI18n)
Vue.use(Vue2Filters)
Vue.use(wysiwyg,
{
  /*
  image: {
  	uploadURL: "/api/myEndpoint",
  	dropzoneOptions: {}
  },
  */
  maxHeight: "500px",
  forcePlainTextOnPaste: true
});
Vue.use(CKEditor);

Vue.component('vueselectimage', VueSelectImage)
Vue.component('draggable', draggable)
Vue.component('pagination', Pagination)
Vue.component('fileupload', FileUpload)
Vue.component('fileuploadnew', FileUploadNew)
Vue.component('loading', Loading);
Vue.component('timepicker', DateTimePicker)
Vue.component('timepickersec', VueTimepicker)
Vue.component('lbdatepicker', LbDateTimePicker)

Vue.component('datepicker', Datepicker)
Vue.component('icon', FontAwesomeIcon)
Vue.component('autocomplete', Autocomplete)
Vue.component('inputvalidation', InputValidation)

Vue.config.productionTip = false
const i18n = new VueI18n(
{});

new Vue(
{
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
